module.exports = __webpack_public_path__ + "img/figure-1.51c851dd.png";